
import { defineComponent } from "vue";
import { useDataSource, useGammaData } from "@/services";
import { mapState } from "pinia";

export default defineComponent({
  name: "PageSizeSelector",
  props: {
    pageSize: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    sizes: [10, 25, 50, 100],
  }),
  computed: {
    ...mapState(useGammaData, ["activeSourceId"]),
  },
  methods: {
    setPageSize(size: number) {
      if (this.activeSourceId) {
        const ds = useDataSource(this.activeSourceId)();
        ds.update("paging", {
          ...ds.paging,
          size,
        });
      }
    },
  },
});
